module.exports = __webpack_public_path__ + "static/3-d33f9bfda1e4b352726026e3f8a316be.jpg";